<template>
    <div class="cr:max-w-4xl">
        <LoadingSpinner v-if="registrationStore.initializing"/>
        <div class="cr:rounded-lg cr:bg-white cr:p-7" v-else>
            <Transition name="slide" mode="out-in">
                <Component
                    :is="slidesStore.componentMap[slidesStore.currentSlide]"
                    :ref="setSlideRef"
                    @next-slide="slidesStore.nextSlide()"
                />
            </Transition>
            <div class="cr:grid cr:md:grid-cols-2 cr:gap-5 cr:items-center">
                <div>
                    <CustomButton
                        :color="'slate-outline'"
                        @click="slidesStore.previousSlide()"
                        v-if="!slidesStore.hideBackButton"
                        :width-class="'cr:w-full'"
                    >
                        Back
                    </CustomButton>
                </div>
                <div>
                    <CustomButton
                        :color="'origin'"
                        @click="submitSlide"
                        v-if="!slidesStore.hideNextButton"
                        :width-class="'cr:w-full'"
                        :disable-button="disableContinue || saving"
                    >
                        Continue
                    </CustomButton>
                </div>
            </div>
            <div class="cr:mt-7 cr:text-center">
                Call us today to schedule a demo at
                <a :href="`tel:${configStore.supportPhone}`" class="cr:text-blue-500 cr:font-semibold">{{ configStore.supportPhone }}</a>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

import {useSlidesStore} from "@/stores/slides.ts";
import CustomButton from "@/components/elements/CustomButton.vue";
import {computed, type Ref, ref} from "vue";
import {useRegistrationStore} from "@/stores/registration.ts";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {useErrorStore} from "@/stores/error.ts";
import {useConfigStore} from "@/stores/config.ts";
interface ChildComponentType {
    canContinue: boolean;
    slidePayload: any,
    validate: any
}

const slidesStore = useSlidesStore();
const registrationStore = useRegistrationStore();
const errorStore = useErrorStore();
const configStore = useConfigStore();
const slide: Ref<ChildComponentType|null> = ref(null);
const saving: Ref<boolean> = ref(false);
const disableContinue = computed(() => !slide.value || !slide.value.canContinue);
const setSlideRef = (el: any) => slide.value = el;
const submitSlide = () => {
    if (slide.value?.validate && !slide.value?.validate()) {
        return;
    }

    saving.value = true;
    registrationStore.submitSlideData(slide.value?.slidePayload ?? {})
        .then(resp => handleResponse(resp))
        .catch(e => handleError(e))
        .finally(() => saving.value = false);
}

const handleResponse = (resp: any) => {
    if (resp.data.data.status) {
        if (resp.data.data.reference) {
            registrationStore.registeringCompany.reference = resp.data.data.reference;
        }

        if (resp.data.data.user_reference) {
            registrationStore.registeringCompany.userReference = resp.data.data.user_reference;
        }

        if (resp.data.data.email_can_log_in) {
            registrationStore.registeringCompany.emailCanLogin = resp.data.data.email_can_log_in;
        }
        if (resp.data.data.is_duplicate) {
            registrationStore.registeringCompany.isDuplicated = resp.data.data.is_duplicate;
        }

        slidesStore.nextSlide();

        return;
    }

    errorStore.report('Something went wrong. Please try again.')
}
const handleError = (e: any) => {
    let error = 'Something went wrong. Please try again'

    if (e.response?.status === 422) {
        error = e.response.data?.message ?? 'Please fill in all required fields with valid data.';
    }

    errorStore.report(error);

    console.error(e);
}

</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
    opacity: 1;
    transition: opacity 0.5s ease-in 0s;
}

.slide-enter-from,
.slide-leave-to {
    opacity: 0;
    transition: opacity 0.5s 0s;
}
</style>